// extracted by mini-css-extract-plugin
module.exports = {"scrollCard":"ScrollCard_scrollCard__PH1Tc"};